<template>
    <BreadCrumb PageTitle="Modifier un service" />
    <EditService />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue"
    import EditService from "@/components/Service/EditService.vue";
  
    export default defineComponent({
      name: "EditServicePage",
      components: {
        BreadCrumb,
        EditService,
      },
    });
  </script>